import script from "./account-table-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./account-table-item.vue?vue&type=script&setup=true&lang=ts"

import "./account-table-item.vue?vue&type=style&index=0&id=ff88a4eb&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff88a4eb"]])

export default __exports__